import React from 'react';
import ModalCard, { modalSize } from 'shared-assets/components/Modal/ModalCard';
import Grid from '@material-ui/core/Grid';
import update from 'immutability-helper';
import { Box, Button } from '@kareo/design-system';
import CachedDataWarning from 'shared-assets/facesheet-ui/components/Facesheet/Error/CachedDataWarning';
import { CACHED_DATA_MESSAGE } from 'shared-assets/facesheet-ui/service/patient/types';

class NoAssignModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      restrictedList: [],
    };
  }

  async componentDidMount() {
    const users = await this.props.getAllUsers();
    const restrictedGuids = await this.props.getRestrictedList(
      this.props.patientId,
    );
    const restrictedNames = users.filter(user =>
      restrictedGuids.linkedUsers.includes(user.userGuid),
    );
    this.setState({
      restrictedList: update(this.state.restrictedList, {
        $set: restrictedNames,
      }),
    });
  }

  render() {
    return (
      <ModalCard
        open={this.props.open}
        disableClearable
        header={
          <div style={{ marginTop: '11px', marginBottom: '11px' }}>
            Restricted Access to {this.props.firstName} {this.props.lastName}
          </div>
        }
        size={modalSize.default}
        closeIcon
        cardStyle={{
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        onClose={this.props.handleClose}
        footer={
          <Grid container direction="row-reverse">
            <Grid item>
              <Button onClick={this.props.handleClose} color="vitality">
                Close
              </Button>
            </Grid>
          </Grid>
        }
      >
        <If
          condition={this.props.cachedChartAccessContext?.isCachedDataDisplayed}
        >
          <Box mb={1}>
            <CachedDataWarning
              messageType={CACHED_DATA_MESSAGE.WITH_DATE}
              lastCachedDate={
                this.props.cachedChartAccessContext?.lastCachedDate
              }
              displayBorder
            />
          </Box>
        </If>
        <span>
          You do not have access to view this patient&apos;s clinical{' '}
          {this.props.dataRestrictionEnabled ? 'data' : 'notes'}. To request
          access, please contact:
        </span>
        <ul style={{ all: 'revert', margin: '0' }}>
          <li
            style={{
              listStyleType: 'disc',
              display: 'list-item',
            }}
          >
            Front desk or an Administrator
          </li>
          <If condition={this.state.restrictedList.length > 0}>
            <li>
              {this.state.restrictedList.map(
                user =>
                  `${user.firstName} ${user.lastName}${
                    this.state.restrictedList.length > 1 ? `, ` : ``
                  }`,
              )}
            </li>
          </If>
        </ul>
      </ModalCard>
    );
  }
}

export default NoAssignModal;
